import React from "react";
import { Button } from "antd";
import { PhoneNumberObj } from "../whatsappBusinessAccount/onBoardingProcess/twilioPhoneNumberSelector/TwilioPhoneCatalogPicker";
import WhatsappIntegrationButton from "../whatsappIntegrationButton/WhatsappIntegrationButton";
import StepIntroBubble from "./StepIntroBubble";

type UILang = "en" | "he";

const META_TR = {
  en: {
    title: "Connect your number to WhatsApp",
    p1: "Click the button below to open Meta's official onboarding popup.",
    p2: "You'll sign in with a Facebook account that has business admin access, then create or select your Meta Business Portfolio and WhatsApp Business Account.",
    p3: "Review and approve the requested permissions, then complete the flow until Meta confirms success. If the popup is idle too long, restart and continue.",
    mock_success: "Mock success",
    mock_failure: "Mock failure",
    mock_mode: (mode: string) => `Current mock mode: ${mode}`,
  },
  he: {
    title: "חברו את המספר ל-WhatsApp",
    p1: "לחצו על הכפתור למטה כדי לפתוח את חלון ה-onboarding הרשמי של Meta.",
    p2: "תיכנסו עם חשבון Facebook שיש לו גישת מנהל עסקי, ואז תיצרו או תבחרו את תיק העסקים ב-Meta וחשבון ה-WhatsApp Business.",
    p3: "בדקו ואשרו את ההרשאות המבוקשות, ואז השלימו את הזרימה עד ש-Meta מאשרת הצלחה. אם החלון לא פעיל יותר מדי זמן, הפעילו מחדש והמשיכו.",
    mock_success: "הצלחה מדומה",
    mock_failure: "כישלון מדומה",
    mock_mode: (mode: string) => `מצב מדומה נוכחי: ${mode}`,
  },
};

type Props = {
  lang?: UILang;
  canInteract: boolean;
  isActive: boolean;
  showTestingActions?: boolean;
  activePhoneNumber?: string;
  selectedByonPhoneNumber: PhoneNumberObj | null;
  selectedCatalogPhoneNumber: PhoneNumberObj | null;
  onMetaCompleted: () => void;
  onMetaFailed: () => void;
  onMetaStarted: () => void;
};

const Step3MetaFlowBubble = ({
  lang = "en",
  canInteract,
  isActive,
  showTestingActions = false,
  activePhoneNumber,
  selectedByonPhoneNumber,
  selectedCatalogPhoneNumber,
  onMetaCompleted,
  onMetaFailed,
  onMetaStarted,
}: Props) => {
  const tr = META_TR[lang];
  const disabled = !canInteract || !isActive;
  const selectedPhoneForMeta =
    activePhoneNumber || selectedByonPhoneNumber?.phoneNumber || selectedCatalogPhoneNumber?.phoneNumber;
  const mockMode =
    typeof window !== "undefined"
      ? String(window.localStorage.getItem("v2_mock_meta_onboarding") || "").toLowerCase()
      : "";

  return (
    <StepIntroBubble
      stepNumber={3}
      title={tr.title}
      paragraphs={[tr.p1, tr.p2, tr.p3]}
      actions={showTestingActions ? (
        <>
          <Button
            type="default"
            className="link"
            disabled={disabled}
            onClick={() => {
              window.localStorage.setItem("v2_mock_meta_onboarding", "success");
              onMetaCompleted();
            }}
          >
            {tr.mock_success}
          </Button>
          <Button
            type="default"
            className="link"
            disabled={disabled}
            onClick={() => {
              window.localStorage.setItem("v2_mock_meta_onboarding", "failure");
              onMetaFailed();
            }}
          >
            {tr.mock_failure}
          </Button>
          {mockMode ? <div className="v2oa-text">{tr.mock_mode(mockMode)}</div> : null}
        </>
      ) : undefined}
    >
      <div className="v2oa-complex-content">
        <div style={disabled ? { pointerEvents: "none", opacity: 0.55 } : undefined}>
          <WhatsappIntegrationButton
            shouldDisplayPhoneDialog={Boolean(selectedByonPhoneNumber?.phoneNumber)}
            byonNumber={selectedPhoneForMeta}
            lang={lang}
            onCompleteMetaOnboarding={onMetaCompleted}
            onFailMetaOnboarding={onMetaFailed}
            onStartMetaOnboarding={onMetaStarted}
          />
        </div>
      </div>
    </StepIntroBubble>
  );
};

export default Step3MetaFlowBubble;
